import { AccountId } from "caip"
import { BlockId, ChainId } from "query/graphql"

export const parseBlockId = (id: BlockId): {
  chainId: ChainId
  number: number
} => {
  const [namespace, reference, number] = id.split(":")
  return {
    chainId: [namespace, reference].join(":"),
    number: Number(number),
  }
}
